import Config from '@config';
import { normalizeInfiniteQueryData } from '@gasbi/shared/common/features/utils';
import { useSelector } from 'react-redux';

import { injectAdminSlice } from '@/app/adminApi';
import { FiltersGrid, Pagination } from '@/features/types';
import { cachedItemByIdSelector, infiniteQueryOptions } from '@/features/utils';

import { OrganizationListItemReadModel, OrganizationReadModel } from './types';

// The ГРМ card is created and saved over gdn-organizations (features/organizations, PO, 2026-10-27). The list is the
// ГРМ only (gdn-organizations/query): the admin also holds «Адміністрація» and the ГРМ's структурні підрозділи.
export const organizationApi = injectAdminSlice({
  baseUrl: Config.VITE_API_URL,
  tagTypes: ['Organization'],
  endpoints: builder => ({
    getOrganizations: builder.infiniteQuery<
      OrganizationListItemReadModel[],
      FiltersGrid,
      Pagination
    >({
      infiniteQueryOptions,
      query: ({ queryArg, pageParam }) => ({
        url: '/gdn-organizations/query',
        method: 'GET',
        params: { ...queryArg, ...pageParam },
      }),
      providesTags: () => ['Organization'],
    }),
    getOrganizationById: builder.query<OrganizationReadModel, string>({
      query: id => ({ url: `/organizations/${id}`, method: 'GET' }),
      providesTags: (_result, _error, id) => [{ type: 'Organization', id }],
    }),
  }),
});

export const useGetOrganizationsInfiniteQuery = normalizeInfiniteQueryData(
  organizationApi.useGetOrganizationsInfiniteQuery,
);

const getCachedOrganizationByIdSelector = cachedItemByIdSelector(
  organizationApi.reducerPath,
  'getOrganizations',
);

export const useGetCachedOrganizationByIdSelector = (id: string) =>
  useSelector(getCachedOrganizationByIdSelector(id));

export const { useGetOrganizationByIdQuery } = organizationApi;
